exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._icon__icon__3sjiD {\n  display: inline;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: normal;\n  font-stretch: normal;\n  font-size: inherit;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow: hidden;\n  text-align: center; }\n\n._icon__spin__1aQr1 {\n  animation: _icon__spin-circle__wtuuX 2s infinite linear; }\n\n@keyframes _icon__spin-circle__wtuuX {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(359deg); } }\n", ""]);

// exports
exports.locals = {
	"icon": "_icon__icon__3sjiD",
	"spin": "_icon__spin__1aQr1",
	"spin-circle": "_icon__spin-circle__wtuuX"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]__[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./~/rctui/styles/_icon.scss
// module id = 389
// module chunks = 0 1